<template>
  <div class="section-error" data-testid="section-error">
    <Heading :level="3" class="section-error__title">
      {{ title }}
    </Heading>
    <BaseText class="section-error__description" size="md">
      {{ description }}
    </BaseText>

    <ButtonSecondary
      class="section-error__retry"
      data-testid="section-error-retry"
      size="large"
      :label="buttonLabel"
      icon="EA0130"
      icon-position="right"
      @click="onRetry"
    />
  </div>
</template>

<script lang="ts">
import { Component, Emit, Vue, Prop } from 'vue-property-decorator';
import {
  SkeletonLoader,
  BaseText,
  Heading,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

@Component({
  name: 'SectionError',
  components: { SkeletonLoader, BaseText, Heading, ButtonSecondary }
})
export default class SectionError extends Vue {
  @Prop({ type: String, required: true })
  readonly title!: string;

  @Prop({ type: String, required: true })
  readonly description!: string;

  @Prop({ type: String, default: 'Tentar novamente' })
  readonly buttonLabel!: string;

  @Emit('on-retry')
  public onRetry() {}
}
</script>

<style lang="less" scoped>
@negative-button-margin: calc(@size-spacing-x350 * -1);

.section-error {
  max-width: 445px;
  width: 100%;

  &__title {
    margin-top: @size-spacing-x500;
    color: @element-over-image;
  }

  &__description {
    margin-top: @size-spacing-x300;
    color: @element-over-image;
  }

  &__retry {
    margin-top: @size-spacing-x400;
    margin-left: @negative-button-margin;

    ::v-deep span {
      color: @element-over-image;
    }
  }
}
</style>
